"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInArray = exports.getCountryNameFromCode = exports.getTaxMessage = exports.getCurrencyFromCountryCode = void 0;

var PaymentForm_models_1 = require("./PaymentForm.models");

var countries_list_1 = __importDefault(require("countries-list"));

var getCurrencyFromCountryCode = function getCurrencyFromCountryCode(countryCode) {
  var currencyMapping = new Map([[PaymentForm_models_1.CountryCode.GB, PaymentForm_models_1.Currency.GBP], [PaymentForm_models_1.CountryCode.US, PaymentForm_models_1.Currency.USD], [PaymentForm_models_1.CountryCode.CA, PaymentForm_models_1.Currency.CAD], [PaymentForm_models_1.CountryCode.AU, PaymentForm_models_1.Currency.AUD], [PaymentForm_models_1.CountryCode.JP, PaymentForm_models_1.Currency.JPY], [PaymentForm_models_1.CountryCode.CH, PaymentForm_models_1.Currency.CHF]]);
  return currencyMapping.get(countryCode) || PaymentForm_models_1.Currency.EUR;
};

exports.getCurrencyFromCountryCode = getCurrencyFromCountryCode;
var messagesInclusive = new Map([[PaymentForm_models_1.Currency.GBP, 'including estimated VAT'], [PaymentForm_models_1.Currency.USD, 'including estimated local taxes'], [PaymentForm_models_1.Currency.EUR, 'including estimated VAT'], // we're currently not charging tax in these countries as we're operating under the threshold
[PaymentForm_models_1.Currency.CAD, ''], [PaymentForm_models_1.Currency.JPY, ''], [PaymentForm_models_1.Currency.AUD, ''], [PaymentForm_models_1.Currency.CHF, '']]);
var messagesExclusive = new Map([[PaymentForm_models_1.Currency.GBP, 'plus VAT'], [PaymentForm_models_1.Currency.USD, 'plus tax'], [PaymentForm_models_1.Currency.EUR, '(plus VAT)'], // see above
[PaymentForm_models_1.Currency.CAD, ''], [PaymentForm_models_1.Currency.JPY, ''], [PaymentForm_models_1.Currency.AUD, ''], [PaymentForm_models_1.Currency.CHF, '']]);

var getTaxMessage = function getTaxMessage(taxInclusive, currency) {
  var taxMessage = taxInclusive ? messagesInclusive.get(currency) : messagesExclusive.get(currency);
  return taxMessage ? taxMessage : '';
};

exports.getTaxMessage = getTaxMessage;

var getCountryNameFromCode = function getCountryNameFromCode(code) {
  return countries_list_1.default.countries[code] ? countries_list_1.default.countries[code].name : 'Invalid Code';
};

exports.getCountryNameFromCode = getCountryNameFromCode;

var isInArray = function isInArray(item, items) {
  return items.some(function (i) {
    return i === item;
  });
};

exports.isInArray = isInArray;